import type { Block } from '@pageboss/shared';
import { InspectorSection } from './inspector-section';
import { InspectorField } from './inspector-field';
import { Repeater, RepeaterTitle } from './repeater';
import { IconPicker, IconPreview } from './icon-picker';

type CredentialsBlock = Extract<Block, { type: 'credentials' }>;
type CredentialsProps = CredentialsBlock['props'];
type CredentialsItem = CredentialsProps['items'][number];

function newChip(): CredentialsItem {
  return { icon: '⭐', label: 'New chip' };
}

interface CredentialsInspectorProps {
  block: CredentialsBlock;
  onChange: (next: CredentialsProps) => void;
}

export function CredentialsInspector({ block, onChange }: CredentialsInspectorProps) {
  const props = block.props;
  const patch = (next: Partial<CredentialsProps>) => onChange({ ...props, ...next });

  return (
    <InspectorSection label="Chips">
      <Repeater
        items={props.items}
        onChange={(items) => patch({ items: items as CredentialsProps['items'] })}
        addLabel="Add chip"
        makeNew={newChip}
        renderTitle={(item) => (
          <>
            {item.icon ? (
              <IconPreview value={item.icon} className="mr-1 inline-block h-3.5 w-3.5 align-text-bottom text-brand-700" />
            ) : null}
            <RepeaterTitle>{item.label}</RepeaterTitle>
          </>
        )}
        renderForm={(item, _i, update) => (
          <>
            <IconPicker
              label="Icon (optional)"
              value={item.icon ?? ''}
              helperText="Shown before the label on the trust strip"
              onChange={(v) => update({ icon: v })}
            />
            <InspectorField
              label="Label"
              value={item.label}
              placeholder="Licensed & Insured"
              onChange={(v) => update({ label: v })}
            />
          </>
        )}
      />
    </InspectorSection>
  );
}
